export default __webpack_public_path__ + "static/media/DouglasLopes_09.380580e9.jpg";